export const enum State {
  Loading,
  Indeterminate,
  Successful,
  Error
}
